import request from '@/utils/request'

// 验证码
export function captcha () {
  return request({
    url: '/captcha',
    method: 'get'
  })
}

// 登录
export function login (data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

// 登录
export function isBindGGAuth (data) {
  return request({
    url: '/isBindGGAuth',
    method: 'post',
    data
  })
}

// 菜单
export function menu () {
  return request({
    url: '/admin/role',
    method: 'get'
  })
}

// 修改密码
export function passwordEdit (data) {
  return request({
    url: '/admin/changePassword',
    method: 'post',
    data
  })
}
